module.exports = __webpack_public_path__ + "static/media/lk.d53b60dc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lk.svg
// module id = 2141
// module chunks = 0